export function init() {
  const form = document.querySelector("form#contact_form");

  const allInputs = Array.from(
    form.querySelectorAll("label + input:not([type=search])")
  );
  const textarea = form.querySelector("textarea");
  textarea.addEventListener("focus", () => {
    let label = textarea.previousElementSibling
    label.classList.add("contact-form-label-small");
  });

  for (let input of allInputs) {
    const label = input.previousElementSibling;
    if (!label) return;
    if (!(input instanceof HTMLInputElement)) return;

    if (input.value !== "") {
      label.classList.add("contact-form-label-small");
    }
    input.addEventListener("focus", () => {
      label.classList.add("contact-form-label-small");
    });
  }
}
